import React from "react";

import classes from "../../pages/terms/style/style.module.css";
import PageName from "../pagename/index";
import { useRouter } from "next/router";
import Link from "next/link";
export default function Arabic() {
  const router = useRouter();
  return (
    <div className={`${router.locale === "en" ? "hidden" : "block"}`}>
      <PageName title={" الشروط والاحكام"} />
      <div className={classes.container}>
        <div className={classes.margin}>
          <br />
          <p className={classes.bold}>آخر تحديث: 17 إبريل 2023</p>
          <br />
          <p>
            إننا في شركة أسكوت (Ascot)، ملتزمون بحماية خصوصية مستخدمينا. توضح
            سياسة الخصوصية هذه كيف نجمع معلوماتك الشخصية ونستخدمها ونكشف عنها
            عندما تستخدم موقع شركتنا. باستخدام موقعنا، فإنك توافق على جمع
            معلوماتك الشخصية واستخدامها والكشف عنها كما هو موضح في هذه السياسة.
          </p>

          <br />
          <p className={classes.bold}>1.المعلومات الشخصية التي نجمعها</p>
          <p>
            قد نقوم بجمع معلومات شخصية منك عند التسجيل للحصول على حساب أو
            استخدام موقعنا، مثل:
          </p>
          <br />
          <ul className={classes.disc}>
            <li>الاسم</li>
            <li>عنوان البريد الإلكتروني</li>
            <li>رقم الهاتف</li>
            <li>اسم الشركة</li>
            <li>المسمى الوظيفي</li>
            <li>الموقع</li>
            <li>عنوان الـ IP</li>
            <li>نوع المتصفح</li>
            <li>معلومات الجهاز</li>
          </ul>
          <br />
          <p className={classes.bold}>
            2. كيف نستخدم المعلومات الشخصية الخاصة بك
          </p>
          <p>نستخدم معلوماتك الشخصية من أجل:</p>
          <br />
          <p>- تمكينك من زيارة موقعنا وخدماته</p>
          <p>- الرد على استفساراتك وتقديم خدمة دعم العملاء</p>
          <p>- تحليل استخدام موقعنا لتحسين وظائفه وتجربة المستخدم</p>
          <p>- التواصل معك حول خدماتنا وعروضنا الترويجية وفعالياتنا</p>
          <p>- الامتثال للالتزامات القانونية</p>
          <br />
          <p className={classes.bold}>3. الكشف عن معلوماتك الشخصية</p>
          <p>قد نشارك معلوماتك الشخصية مع:</p>
          <br />
          <br />
          <p>- الشركات التابعة لنا والشركات التي تعمل معنا لأغراض تجارية</p>
          <p>
            - مقدمو الخدمات من الأطراف الثالثة الذين يساعدوننا في تشغيل موقعنا
            وتقديم خدماتنا، مثل الاستضافة السحابية والتسويق عبر البريد
            الإلكتروني
          </p>
          <p>
            - سلطات إنفاذ القانون أو الوكالات الحكومية أو أطراف ثالثة أخرى وفقًا
            لما يقتضيه القانون
          </p>
          <p className={classes.bold}>4.أمن البيانات</p>
          <p>
            نتخذ تدابير معقولة لحماية معلوماتك الشخصية من الوصول غير المصرح به
            والكشف والتعديل والتدمير. إلا أنه لا يمكن ضمان أن يكون نقل البيانات
            عبر الإنترنت أو نظام التخزين آمنًا بنسبة 100٪.
          </p>
          <br />
          <p className={classes.bold}>5. ملفات تعريف الارتباط</p>
          <p>
            نستخدم ملفات تعريف الارتباط والتقنيات المماثلة لتحسين تجربة المستخدم
            وتخصيص تفاعلاتك مع موقعنا. ملفات تعريف الارتباط هي ملفات بيانات
            صغيرة يتم وضعها على جهازك عندما تزور موقعنا. يمكنك التحكم في استخدام
            ملفات تعريف الارتباط من خلال إعدادات المتصفح الخاص بك
          </p>
          <br />
          <p className={classes.bold}>6. استخدام البيانات</p>
          <p>
            يتم جمع استخدام البيانات تلقائيًا. قد يشمل ذلك معلومات مثل عنوان
            بروتوكول الإنترنت الخاص بجهازك (مثل عنوان الـ IP)، ونوع المتصفح،
            وإصدار المتصفح، وصفحات موقعنا التي تزورها، ووقت وتاريخ زيارتك،
            والوقت الذي تقضيه في تلك الصفحات، ومعرفات الجهاز الفريدة وبيانات
            التشخيص الأخرى. عندما تصل إلى موقعنا عبر أو من خلال جهاز محمول، قد
            نقوم بجمع معلومات معينة تلقائيًا، بما في ذلك، على سبيل المثال لا
            الحصر، نوع الجهاز المحمول الذي تستخدمه، والمعرف الفريد لجهازك
            المحمول، وعنوان الـ IP لجهازك المحمول، ونظام تشغيل هاتفك المحمول،
            ونوع متصفح الإنترنت على الهاتف المحمول الذي تستخدمه، ومعرفات الجهاز
            الفريدة وبيانات التشخيص الأخرى.
          </p>
          <br />
          <br />
          <p>
            قد نقوم أيضًا بجمع المعلومات التي يرسلها متصفحك عندما تزور خدمتنا أو
            عندما تصل إلى الخدمة عن طريق أو من خلال جهاز محمول.
          </p>
          <br />
          <p className={classes.bold}>7.الاحتفاظ بالمعلومات الشخصية</p>
          <p>
            نحتفظ بمعلوماتك الشخصية طالما كان ذلك ضروريًا لتحقيق الأغراض التي تم
            جمعها من أجلها، أو وفقًا لما يقتضيه القانون. قد نحتفظ أيضًا بمعلومات
            معينة لأغراض التحليل أو حفظ السجلات أو الامتثال للالتزامات
            القانونية.
          </p>
          <br />
          <p className={classes.bold}>8.خصوصية الأطفال</p>
          <p>
            إن موقعنا غير مخصص للاستخدام من قبل الأطفال الذين تقل أعمارهم عن 16
            عامًا. نحن لا نجمع معلومات شخصية عن قصد من الأطفال دون سن 16 عامًا.
            إذا كنت أحد الوالدين أو الوصي وتعتقد أن طفلك قد زودنا بمعلومات
            شخصية، فيرجى الاتصال باستخدام المعلومات الواردة في قسم "اتصل بنا"
            ضمن هذه سياسة الخصوصية هذه.
          </p>
          <br />
          <p className={classes.bold}>9.روابط الطرف الثالث</p>
          <p>
            قد يحتوي موقعنا على روابط لمواقع أو خدمات تابعة لجهات خارجية لا يتم
            تشغيلها أو التحكم فيها من قبلنا. لا تنطبق هذه السياسة على مواقع أو
            خدمات الطرف الثالث. نحن لسنا مسؤولون عن ممارسات الخصوصية لمواقع أو
            خدمات الطرف الثالث. نحن نشجعك على مراجعة سياسات الخصوصية لمواقع أو
            خدمات الطرف الثالث قبل تقديم أي معلومات شخصية.
          </p>
          <br />
          <p className={classes.bold}>10. التحليلات والإعلان</p>
          <p>
            يحق لنا استخدام أدوات التحليلات والإعلانات الخاصة بطرف ثالث، مثل
            Google Analytics وإعلانات Google، لتحليل كيفية استخدام موقعنا وعرض
            الإعلانات لك على المواقع الأخرى على الانترنت بناءً على اهتماماتك. قد
            تجمع هذه الأدوات معلومات حول أنشطتك على موقعنا ومواقع الويب الأخرى
            بمرور الوقت.
          </p>
          <br />
          <p className={classes.bold}>11.وسائل التواصل الاجتماعي</p>
          <p>
            قد يتضمن موقعنا ميزات متعلقة بوسائل التواصل الاجتماعي، مثل زر
            الإعجاب على Facebook وزر المشاركة على Twitter وغيرها. وقد تجمع هذه
            الميزات والخدمات عنوان الـ IP الخاص بك، والصفحة التي تزورها على
            موقعنا، وقد تقوم بتعيين ملف تعريف ارتباط لتمكين الميزة والخدمة من
            العمل بشكل صحيح. يتم استضافة ميزات وخدمات وسائل التواصل الاجتماعي من
            قبل طرف ثالث أو يتم استضافتها مباشرة على موقعنا.
          </p>
          <br />
          <br />
          <p className={classes.bold}>12.التغييرات في الملكية أو التحكم</p>
          <p>
            في حالة خضوعنا لدمج أو استحواذ أو بيع كل أو جزء من أصولنا، فقد تكون
            معلوماتك الشخصية من بين الأصول المنقولة أو المفصح عنها. سنخطرك بأي
            تغيير في الملكية أو التحكم عن طريق نشر إشعار على موقعنا أو عبر
            البريد الإلكتروني.
          </p>
          <br />
          <br />

          <p className={classes.bold}>13.إقرار القبول</p>
          <p>
            باستخدام موقعنا، فإنك تقر بأنك قد قرأت وفهمت سياسة الخصوصية هذه
            وتوافق على جمع معلوماتك الشخصية واستخدامها والكشف عنها كما هو موضح
            في هذه السياسة.
          </p>
          <br />
          <br />

          <p className={classes.bold}>14.القانون المنظم</p>
          <p>
            تخضع سياسة الخصوصية هذه للقوانين الأردنية ويتم تفسيرها وفقًا لها.
            يتم حل أي نزاعات تنشأ بموجب هذه السياسة أو فيما يتعلق بها في المحاكم
            الأردنية.
          </p>
          <br />
          <br />

          <p className={classes.bold}>15.التغييرات على سياسة الخصوصية هذه</p>
          <p>
            قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات
            جوهرية عن طريق نشر السياسة المحدثة على موقعنا أو عبر البريد
            الإلكتروني.
          </p>
          <br />
          <br />

          <p className={classes.bold}>16.تواصل معنا</p>
          <p className="mb-[10rem]">
            إذا كانت لديك أي أسئلة أو مخاوف بشأن ممارسات الخصوصية أو هذه
            السياسة، فيرجى التواصل معنا على
            {<a href="mailto:admin@ascot.ws">admin@ascot.ws</a>}
          </p>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
}
